export type UrlIssueIndexParams = {
  owner: string
  repo: string
}

export type IssueSearchTypeVariant = 'ISSUE_HYBRID' | 'ISSUE_ADVANCED'

export const ISSUES_INDEX_CONTENT_PERSISTER_PREFIX = 'repo-issues-dashboard-v1'

export const normalizeIssuesIndexContentStorageQueryKey = (queryKey: readonly unknown[]) =>
  queryKey.length > 4 ? [queryKey[4]] : undefined

export const getIssuesIndexContentQueryDeps = ({
  pathname,
  query,
  page,
}: {
  pathname: string
  query?: string | null
  page?: string | null
}) => {
  const normalizedQuery = query?.trim()
  const searchParams: Record<string, string> = {page: page || '1'}
  if (normalizedQuery) searchParams.q = normalizedQuery

  return {pathname, searchParams}
}

export const getIssuesIndexContentStorageQueryKey = ({
  owner,
  repo,
  query,
  page,
}: UrlIssueIndexParams & {query?: string | null; page?: string | null}) => [
  getIssuesIndexContentQueryDeps({
    pathname: `/${owner}/${repo}/issues`,
    query,
    page,
  }),
]

export const getDefaultIssuesIndexContentStorageQueryKey = ({owner, repo}: UrlIssueIndexParams) =>
  getIssuesIndexContentStorageQueryKey({owner, repo})

// The search type the client requests is resolved by Rails: ISSUE_HYBRID when hybrid/semantic
// search is available (the dotcom default) and ISSUE_ADVANCED otherwise (e.g. single-tenant
// enterprise or when the semantic endpoint is unavailable). Consumers that can't read that value
// (the service worker) default to ISSUE_HYBRID here and try both variants when looking up keys.
// `issues_default_best_match_sort` is assumed fully enabled. `showIssueFieldPills` is always
// `true` since the `issue_fields_index_pills` flag has been graduated.
export const getIssueIndexPageQueryDefaultValues = (
  {owner, repo}: UrlIssueIndexParams,
  issueSearchType: IssueSearchTypeVariant = 'ISSUE_HYBRID',
) => ({
  query: `is:issue state:open repo:${owner}/${repo} sort:relevance-desc`,
  first: 25,
  labelPageSize: 20,
  showIssueFieldPills: true,
  skip: 0,
  type: issueSearchType,
})
